import { saveLog } from "..";
import { HTTP_SUBSTATUS, ERROR_MESSAGES } from "../../constants";
import { handleRequestExceptionsProps } from "../../types/functions";

export const handleRequestExceptions = ({
  error,
  cbMsg,
}: handleRequestExceptionsProps): void => {
  const status = error?.response?.status;
  const subStatus = error?.response?.data?.subStatus;

  if (!(status === 401 && subStatus === HTTP_SUBSTATUS[401].TOKEN_EXPIRED))
    saveLog(error);

  cbMsg && cbMsg(error?.response?.data?.message || ERROR_MESSAGES.UNEXPECTED);
};

/** Forma mejorada de EncodeURIComponente:
 * https://developer.mozilla.org/es/docs/Web/JavaScript/Referencia/Objetos_globales/encodeURIComponent
 * */
export const fixedEncodeURIComponent = (str: string): string =>
  encodeURIComponent(str)
    .replace(/[!'()]/g, escape)
    .replace(/\*/g, "%2A");

/**
 * Estandar para codificar URL
 * Se descodifica en caso de que la url este ya codificada
 * para no codificarla dos veces
 */
export const safeEncodeURIComponent = (search: string): string =>
  fixedEncodeURIComponent(decodeURIComponent(search));
